var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"error-code"},[_vm._v(_vm._s(_vm.$t('errorCode')))]),_vm._v(" "),_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.$t('errorMessage')))]),_vm._v(" "),_c('router-link',{staticClass:"btn-ghost icon-after-start",attrs:{"to":_vm.link('survey-chooser')}},[_vm._v(_vm._s(_vm.$t('actionText')))])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acc8b01e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/common/page404.vue
// module id = 132
// module chunks = 0